import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import { Button, inputStyle, tokens } from './ui/controls';

export function FormPicker({
  kind,
  onSpec,
}: {
  kind: string;
  onSpec: (spec: Record<string, unknown>) => void;
}) {
  const [names, setNames] = useState<string[]>([]);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    setSelected('');
    api.dataviewer.listFormTemplates(kind).then((res) => setNames(res.data.names || [])).catch(() => setNames([]));
  }, [kind]);

  return (
    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={{ fontSize: '0.8rem', fontWeight: 600, color: tokens.textMuted }}>Template</span>
      <select
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        style={{ ...inputStyle, width: 'auto', minWidth: 180 }}
      >
        <option value="">Blank</option>
        {names.map((n) => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
      <Button
        disabled={!selected}
        onClick={async () => {
          const res = await api.dataviewer.getFormTemplate(kind, selected);
          onSpec(res.data as Record<string, unknown>);
        }}
      >
        Load
      </Button>
      <Button variant="subtle" onClick={() => onSpec({})}>Reset to blank</Button>
      {names.length === 0 && (
        <span style={{ fontSize: '0.8rem', color: tokens.textFaint }}>No saved templates for this job type</span>
      )}
    </div>
  );
}
